import { DataListItem, DataViewItem } from '@/types';
import store from '@/store';

export const findInDataByRegisterId = (id: DataListItem['id'] & number, statementObjectData: DataListItem[]): DataViewItem | undefined => {
  if (id && statementObjectData && statementObjectData.length) {
    const findInBranch = (dataChildren) => {
      let found: DataViewItem | undefined;
      found = dataChildren.find((child) => {
        return child.id === id;
      });
      if (!found) {
        dataChildren.some((child, chIndex) => {
          if (child.children) {
            found = findInBranch(child.children);
            found && store.commit('dataManagement/SET_REGISTER_PARENT_LIST_ITEM', dataChildren[chIndex] || {});
            return found;
          }
        });
      }
      return found;
    };

    return findInBranch(statementObjectData);
  } else return undefined;
};
